<template>
  <footer class="footer">
    <b-container>
      <div class="footer--wrapper">
        <b-row>
          <b-col md="5">
            <router-link :to="{ name: 'homepage' }" class="footer--logo">
              <div v-html="logo"></div>
            </router-link>
            <p class="footer--text">
              Fly by è il primo servizio di prenotazione voli online con la stessa assistenza della
              tua agenzia viaggi di fiducia.
            </p>
          </b-col>
          <b-col md="7">
            <b-row>
              <b-col md="4"> </b-col>
              <b-col md="4">
                <div class="footer--link--title">
                  <b>Chi siamo</b>
                </div>
                <router-link :to="{ name: 'about' }" class="footer--link"
                  >Fly by VadoBay di Salabam Solutions</router-link
                >
                <a class="footer--link" href="https://www.salabamsolutions.com" target="_blank"
                  >Salabam Solutions</a
                >
                <router-link
                  v-if="authentication"
                  @click="logout()"
                  :to="{ name: 'homepage' }"
                  class="footer--link"
                  >Logout</router-link
                >
                <router-link v-if="!authentication" :to="{ name: 'dc-sso' }" class="footer--link"
                  >Ho un buono</router-link
                >
              </b-col>
              <b-col md="4">
                <div class="footer--link--title">
                  <b>Termini e condizioni</b>
                </div>
                <router-link :to="{ name: 'terms' }" class="footer--link">
                  Condizioni d'uso</router-link
                >
                <a class="footer--link" :href="site.urlPrivacy" target="_blank">Privacy Policy</a>
                <a class="footer--link" :href="site.urlCookiePolicy" target="_blank"
                  >Cookie policy</a
                >
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr />
        <b-row class="footer--bottom">
          <b-col md="4">
            <a href="#">© SALABAM SRL - P.IVA: 04238550406</a>
          </b-col>
          <b-col md="4">
            <a href="http://www.taiview.com" target="_blank">Ui & Ux Design: taiview.com</a>
          </b-col>
          <b-col md="4">
            <div class="footer--icons">
              <a
                v-if="site.facebook != ''"
                :href="site.facebook"
                target="_blank"
                class="footer--icon"
                v-html="facebook"
              ></a>
              <a
                v-if="site.linkedin != ''"
                :href="site.linkedin"
                target="_blank"
                class="footer--icon"
                v-html="linkedin"
              ></a>
              <a
                v-if="site.instagram != ''"
                :href="site.instagram"
                target="_blank"
                class="footer--icon"
                v-html="instagram"
              ></a>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </footer>
</template>

<script>
import { logo } from '@/components/svg/logos';
import { facebook, instagram, linkedin } from '@/components/svg/social';
import { is_authenticated } from '@/utilities';
import { logout } from '@/api';

export default {
  name: 'page-footer',
  components: {},
  props: {
    footerMenu: String,
    btnText: String,
  },
  created() {
    this.logo = logo;
    this.facebook = facebook;
    this.instagram = instagram;
    this.linkedin = linkedin;
    this.is_authenticated = is_authenticated;
    this.logout = logout;
  },
  data() {
    return {
      site: this.$config.site,
    };
  },
  computed: {
    authentication: {
      get() {
        return this.is_authenticated();
      },
    },
  },
};
</script>

<style lang="scss">
.footer {
  &--wrapper {
    @extend .panel !optional;
    border: 0;
    background-color: $light-gray-blue;
    padding-top: 30px;
    padding-bottom: 75px;
  }
  &--logo {
    width: 100%;
    margin-bottom: $grid-gutter-width;
    padding-bottom: $grid-gutter-width/2;
    border-bottom: 1px solid $light-gray;
    max-width: 400px;
  }
  &--text {
    @include font-primary-medium;
    font-size: $font-size-base;
    color: $text;
    max-width: 400px;
    line-break: 120%;
  }
  &--link {
    font-size: $font-size-sm;
    display: block;
    margin-bottom: 16px;
    &--title {
      margin-bottom: 16px;
    }
  }

  &--bottom {
    text-align: center;
    font-size: 11px;
    a,
    a:hover,
    a:focus,
    a:visited {
      color: $text;
    }
    @include media-breakpoint-up(md) {
      & > div:nth-child(1) {
        text-align: left;
      }
      & > div:nth-child(3) {
        text-align: right;
      }
    }
  }

  &--icons {
    a {
      display: inline-block;
      margin: 20px 10px;
    }
    @include media-breakpoint-up(md) {
      a {
        margin: 0 10px;
      }
    }
  }
}

.btn-to-top {
  width: 60px;
  height: 60px;
  padding: 10px 16px;
  border-radius: 50%;
  font-size: 22px;
  line-height: 22px;
}

.vue-back-to-top {
  z-index: 10 !important;
  .svg {
    //@include dynamic-colors-blend();
  }
}
</style>
